import { createContext, useContext, useEffect, useReducer, useState } from "react";

export const APP_ACTION_TYPE = {
    REFRESH: 'refresh'
}

const initialState = {
    locations: [],
    practitioners: [],
    calendarTimeslotHeight: 120,
    businessStartHour: '9:30 am',
    businessClosingHour: '9:00 pm',
    timeSlotInterval: 15,  
    workWeek: 7,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    maxFileUploadSize: 10, // in MB
    acceptedFileTypes: ['image/jpeg','image/jpg','image/png','application/pdf'],
    acceptedImageFileTypes: ['image/jpeg','image/jpg','image/png'],
    /**
     * keep track of selected customer in case user switches between different screens
     */
    selectedCustomer: null
};

function reducer(prevstate, nextstate) {
    return { ...prevstate, ...nextstate };
}

export const AppContext = createContext({});
export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [appState, updateAppState] = useReducer(reducer, initialState);

    const value = {
        appState,
        updateAppState
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};
